import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import logger from 'redux-logger';
import reducers from './modules/api/reducers';
import AuthService from './services/auth/authService';

import { parseQuery } from './transformations/queryString';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = composeEnhancers(applyMiddleware(thunkMiddleware, logger));

const queryString = parseQuery(window.location);
if (queryString && queryString.auth && queryString.auth !== 'undefined' && queryString.auth !== '') {
  let auth = queryString.auth;
  if (auth.indexOf('#') !== -1) {
    auth = auth.substring(0, queryString.auth.indexOf('#'));
  }
  AuthService.setAuthToken(auth);
}

const initialState = {
  user: {
    token: AuthService.getAuthToken(),
  },
};

export const store = createStore(reducers, initialState, middleware);
